'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handlers;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;

var _defaultTransform = require('./defaultTransform');

var _defaultTransform2 = _interopRequireDefault(_defaultTransform);

var _actionTypes = require('./actionTypes');

var types = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {};

function reset(state, action) {
  var payload = action.payload,
      meta = action.meta;


  if (payload === undefined) {
    var newState = _extends({}, state);
    delete newState[meta.resourceName];
    return newState;
  }

  var resource = { initialized: true, busy: false, payload: payload, previous: null, meta: meta };
  return _extends({}, state, _defineProperty({}, meta.resourceName, resource));
}

function pending(state, action) {
  var payload = action.payload,
      meta = action.meta;

  var previousState = state[meta.resourceName];
  var transformer = function transformer(fn, val) {
    return fn(val, previousState && previousState.payload, false, meta);
  };
  var transforms = meta.definition.transform || _defaultTransform2.default;
  var transformedPayload = Array.isArray(transforms) ? transforms.reduce(function (memo, transform) {
    return transformer(transform, memo);
  }, payload) : transformer(transforms, payload);

  var resource = {
    initialized: previousState && previousState.initialized || false,
    busy: true,
    payload: transformedPayload,
    previous: previousState && previousState.payload,
    meta: meta
  };

  return _extends({}, state, _defineProperty({}, meta.resourceName, resource));
}

function fulfilled(state, action) {
  var meta = action.meta,
      payload = action.payload;

  var previousState = state[meta.resourceName];
  var transformer = function transformer(fn, val) {
    return fn(val, previousState && previousState.payload, true, meta);
  };
  var transforms = meta.definition.transform || _defaultTransform2.default;
  var transformedPayload = Array.isArray(transforms) ? transforms.reduce(function (memo, transform) {
    return transformer(transform, memo);
  }, payload) : transformer(transforms, payload);

  var resource = {
    initialized: true,
    busy: false,
    payload: transformedPayload,
    previous: null,
    meta: meta
  };

  return _extends({}, state, _defineProperty({}, meta.resourceName, resource));
}

function rejected(state, action) {
  var meta = action.meta,
      payload = action.payload;

  var previousState = state[meta.resourceName];
  var resource = {
    initialized: previousState && previousState.initialized || false,
    busy: false,
    payload: previousState.payload,
    previous: null,
    error: payload,
    meta: meta
  };

  return _extends({}, state, _defineProperty({}, meta.resourceName, resource));
}

function clearErrors(state, action) {
  var resourceName = action.meta.resourceName;

  var resource = state[resourceName];

  return _extends({}, state, _defineProperty({}, resourceName, _extends({}, resource, { error: null })));
}

var handlers = (_handlers = {}, _defineProperty(_handlers, types.RESET, reset), _defineProperty(_handlers, types.PENDING, pending), _defineProperty(_handlers, types.FULFILLED, fulfilled), _defineProperty(_handlers, types.REJECTED, rejected), _defineProperty(_handlers, types.CLEAR_ERRORS, clearErrors), _handlers);

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var type = action.type,
      meta = action.meta;

  if (!type || !type.startsWith(types.PREFIX)) return state;
  if (type === types.NUKE) return {};
  if (!meta || !meta.resourceName) {
    throw new Error('Invalid ' + type + ': Missing "meta.resourceName" property');
  }

  if (handlers[type]) {
    return handlers[type](state, action);
  } else {
    throw new Error('Unrecognized action type: ' + type);
  }
}


//////////////////
// WEBPACK FOOTER
// ../dist/reducer.js
// module id = 895
// module chunks = 0